const _ = require('lodash');

class ControlTypeRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('control-type-column');
    this._rootElem.component = this._model;

    this._registerListeners();
    this.render();
  }

  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/

  _shutdown() {
    let prom = new Promise((resolve /*,reject*/) => {
      this._unregisterListeners();
      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
    return prom;
  }

  _registerListeners() {
    this._model.on(
      'ControlType',
      (this._onControlTypeColumn = this._onControlTypeColumn.bind(this))
    );
  }

  _unregisterListeners() {
    this._model.removeAllListeners('ControlType');
  }

  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    let prom = new Promise((resolve /*,reject*/) => {
      this._setControlTypeColumn(this._model.getValue());
      resolve();
    });
    return prom;
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /*******************************************/
  /* END COMPONENT RENDERER METHODS          */
  /* START HANDLER METHODS                   */
  /*******************************************/

  _onControlTypeColumn(newVal) {
    this._setControlTypeColumn(newVal);
  }

  /*******************************************/
  /* END HANDLER METHODS                     */
  /* START PRIVATE API METHODS               */
  /*******************************************/

  _setControlTypeColumn(newVal) {
    if (!_.isNil(newVal)) {
      this._rootElem.innerHTML = _.get(this._model._controlTypes, newVal, 'N/A');
    } else {
      this._rootElem.innerHTML = 'N/A';
    }
  }

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}

export default ControlTypeRenderer;
